import React, { useState } from "react";
import { Form, TreeSelect, Row, Col } from "antd";
import { errorMessage } from "../../../helpers/errorMessageFunc";
import {
    backendGetRequest,
    backendPatchWithoutRefresh,
} from "../../../helpers/callBackend";
import LoadingButton from '@mui/lab/LoadingButton';

const { TreeNode } = TreeSelect;

const TagTransactionInput = ({ record }) => {
    const [form] = Form.useForm();
    const [accountLedgerData, setAccountLedgerData] = useState([]);
    const [inFlight, setInFlight] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(true);


    let childCategory = [];
    let parentCategory = [];
    let temp = [];

    const handleSubmit = async () => {
        try {
            setInFlight(true);
            const values = await form.validateFields();

            if (!values.category || values.category.length === 0) {
                errorMessage("Category Cannot be Empty");
                setInFlight(false);
                return;
            }

            // You may want to send all selected categories:
            const categoryData = values.category.map((entry) => {
                const [parentCategory, category] = entry.split("::");
                return { parentCategory, category };
            });

            // Example of updating only the first one — adjust logic as needed
            const data = {
                id: record["id"],
                parentCategory: categoryData[0].parentCategory,
                category: categoryData[0].category,
            };

            // Optional: attach to values if needed
            values.parentcategory = data.parentCategory;
            values.category = data.category;

            if (data.category && data.parentCategory) {
                await backendPatchWithoutRefresh("/api/transactions/", data);
            } else {
                errorMessage("Category field cannot be empty");
            }

            setInFlight(false);
        } catch (errInfo) {
            console.error("Save failed:", errInfo);
            setInFlight(false);
        }
    };


    React.useEffect(() => {
        backendGetRequest(
            "/api/general-ledger/account",
            {},
            "loadingGeneralLedgerAccount"
        ).then((res) => {
            setAccountLedgerData(res?.data?.general_ledger_account);
        });
    }, []);

    React.useEffect(() => {
        if (record.info?.category) {
            form.setFieldsValue({
                category: `${record.info?.parentcategory}::${record.info?.category}`,
            });
        } else {
            form.resetFields(['category']);
        }
    }, [record.id]);


    for (let j = 0; j < accountLedgerData.length; j++) {
        var val =
            accountLedgerData[
            accountLedgerData.findIndex(
                (item) => item.id === accountLedgerData[j].total_into_id
            )
            ];
        let parentCat = val ? val["description"] : "";
        if (
            accountLedgerData[j]["description"].split(" ")[0] !== "TOTAL" &&
            parentCat !== ""
        ) {
            if (!temp.includes(parentCat)) {
                temp.push(parentCat);
                parentCategory.push([parentCat, val["report_type"]]);
            }
            childCategory.push([
                accountLedgerData[j]["description"],
                parentCat,
            ]);
        }
    }

    return (
        <Col span={24}>
            <Form form={form} onFinish={handleSubmit} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Form.Item
                    style={{
                        margin: 0,
                        padding: 0,
                        width: "70%",
                        marginRight: '10px',
                    }}
                    name={"category"}
                >
                    <TreeSelect
                        showSearch
                        style={{
                            width: "100%",
                        }}
                        showArrow={true}
                        treeCheckable={true}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto', zIndex: 2000 }}
                        placeholder="Pick a Category"
                        onFocus={() => setButtonDisabled(false)}
                        allowClear
                    >
                        <TreeNode
                            value={"Balance Sheet"}
                            title={"Balance Sheet"}
                            selectable={false}
                        >
                            {parentCategory.map((head) =>
                                head[1] === "BAL" ? (
                                    <TreeNode
                                        value={head[0]}
                                        title={head[0]}
                                        selectable={false}
                                    >
                                        {childCategory.map((account) =>
                                            account[1] === head[0] ? (
                                                <TreeNode
                                                    value={
                                                        head[0] + "::" + account[0]
                                                    }
                                                    title={account[0]}
                                                />
                                            ) : (
                                                ""
                                            )
                                        )}
                                    </TreeNode>
                                ) : (
                                    ""
                                )
                            )}
                        </TreeNode>
                        <TreeNode
                            value={"Income Sheet"}
                            title={"Income Sheet"}
                            selectable={false}
                        >
                            {parentCategory.map((head) =>
                                head[1] === "INC" ? (
                                    <TreeNode
                                        value={head[0]}
                                        title={head[0]}
                                        selectable={false}
                                    >
                                        {childCategory.map((account) =>
                                            account[1] === head[0] ? (
                                                <TreeNode
                                                    value={
                                                        head[0] + "::" + account[0]
                                                    }
                                                    title={account[0]}
                                                />
                                            ) : (
                                                ""
                                            )
                                        )}
                                    </TreeNode>
                                ) : (
                                    ""
                                )
                            )}
                        </TreeNode>
                    </TreeSelect>
                </Form.Item>

                <Row justify="end">
                    <LoadingButton
                        htmlType="submit" disabled={buttonDisabled || inFlight} loading={inFlight}
                        disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                        sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}>
                        Submit
                    </LoadingButton>
                </Row>
            </Form>
        </Col>
    );
};

export default TagTransactionInput;